import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pt-2 pl-2" }
const _hoisted_2 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_3 = ["viewBox"]
const _hoisted_4 = ["xlink:href", "height", "width"]
const _hoisted_5 = ["id", "points", "onClick", "onMouseover", "onMouseout"]
const _hoisted_6 = ["points", "onMouseover", "onMouseout", "onClick"]
const _hoisted_7 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"50vw"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "text-red"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_16 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_17 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_18 = { style: {"color":"red"} }
const _hoisted_19 = { style: {"color":"red"} }
const _hoisted_20 = { style: {"overflow":"hidden"} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  id: "ValidDocumentValidation",
  class: "d-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_DocumentValidationSpeedRun = _resolveComponent("DocumentValidationSpeedRun")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_DocumentWizardDialog = _resolveComponent("DocumentWizardDialog")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "6",
          class: "pr-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "default_card_wm elevation-0 pt-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentMenu, {
                  MenuOptions: _ctx.documentMenuOptions,
                  onBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                  onZoomOut: _cache[1] || (_cache[1] = ($event: any) => (_ctx.zoomManager.zoomOut())),
                  onResetZoom: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomManager.resetZoom())),
                  onZoomIn: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomManager.zoomIn())),
                  onRotateLeft: _cache[4] || (_cache[4] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('left', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                  onRotateRight: _cache[5] || (_cache[5] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('right', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                  onOcrChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOCRChanged())),
                  onClearSelectedText: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emptySelectedText())),
                  onDownload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startDownloadFile())),
                  onDisplayItem: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showBankTransactions = true)),
                  onDisplayDocument: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showBankTransactions = false)),
                  onAnalyse: _cache[11] || (_cache[11] = ($event: any) => (_ctx.analyseDocumentDialog = true)),
                  onDelete: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteDocumentDialog = true)),
                  selectedText: _ctx.selectedText,
                  "onUpdate:selectedText": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedText) = $event))
                }, null, 8, ["MenuOptions", "selectedText"]),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    (!_ctx.showBankTransactions && _ctx.isPDF)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ossPdf, {
                              rotation: _ctx.documentPdfRotation,
                              documentId: _ctx.document.id
                            }, null, 8, ["rotation", "documentId"])
                          ]),
                          _: 1
                        }))
                      : (!_ctx.showBankTransactions && _ctx.document.signedUrl)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            style: {"max-height":"85vh","overflow-y":"auto"}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                (_ctx.document)
                                  ? (_openBlock(), _createElementBlock("svg", {
                                      id: "svg-document-bank-statement-validation",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "100%",
                                      viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                      style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"},
                                      key: _ctx.showOCR
                                    }, [
                                      _createElementVNode("g", null, [
                                        _createElementVNode("image", {
                                          id: "svg-image-document-bank-statement-validation",
                                          "xlink:href": _ctx.document.signedUrl,
                                          x: "0",
                                          y: "0",
                                          height: `${_ctx.imageHeight}px`,
                                          width: `${_ctx.imageWidth}px`
                                        }, null, 8, _hoisted_4),
                                        (!_ctx.showOCR)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.identifiedBankTransactions, (bt) => {
                                              return (_openBlock(), _createElementBlock("polygon", {
                                                key: `coord-${_ctx.document.id}-${bt.index}`,
                                                ref_for: true,
                                                ref: `svg-bt-${bt.index}`,
                                                id: `svg-bt-${bt.index}`,
                                                points: _ctx.getTokenPoints(bt),
                                                style: _normalizeStyle(
                                                        _ctx.selectedBT && bt === _ctx.selectedBT
                                                            ? 'fill:rgba(0,250,0,0.5);stroke:#F9B12A;stroke-width:1'
                                                            : 'fill:rgba(0,250,0,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                    ),
                                                onClick: _withModifiers(($event: any) => (_ctx.onClickBT(bt)), ["stop"]),
                                                onMouseover: ($event: any) => (_ctx.highlightBT(bt, true, 'identified')),
                                                onMouseout: ($event: any) => (_ctx.highlightBT(bt, false)),
                                                class: _normalizeClass(
                                                        bt.focus
                                                            ? 'highlighted'
                                                            : bt.amountSigned
                                                              ? ''
                                                              : 'error'
                                                    )
                                              }, null, 46, _hoisted_5))
                                            }), 128))
                                          : _createCommentVNode("", true),
                                        (
                                                _ctx.showOCR &&
                                                _ctx.ocr &&
                                                _ctx.ocr.sentences &&
                                                _ctx.ocr.sentences.length
                                            )
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.ocr.sentences, (sentence, sIndex) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentence.tokens, (token, tIndex) => {
                                                  return (_openBlock(), _createElementBlock("polygon", {
                                                    key: `sentence-${sIndex}-token-${tIndex}`,
                                                    ref_for: true,
                                                    ref: `sentence-${sIndex}-token-${tIndex}`,
                                                    points: _ctx.getTokenPoints(token),
                                                    style: _normalizeStyle(_ctx.getTokenStyle(token)),
                                                    onMouseover: ($event: any) => (token.high = true),
                                                    onMouseout: ($event: any) => (token.high = false),
                                                    onClick: _withModifiers(($event: any) => (_ctx.onClickToken(token)), ["stop"])
                                                  }, null, 44, _hoisted_6))
                                                }), 128))
                                              ], 64))
                                            }), 256))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 8, _hoisted_3))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : (_ctx.showBankTransactions)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "12",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_virtual_scroll, {
                                  "item-height": 75,
                                  items: _ctx.bankTransactions,
                                  height: "750",
                                  class: "py-3",
                                  bench: "2"
                                }, {
                                  default: _withCtx(({ item }) => [
                                    (_openBlock(), _createBlock(_component_v_row, {
                                      "no-gutters": "",
                                      key: item.id,
                                      inactive: "",
                                      class: "oss-list-item-inactive",
                                      style: {"background":"rgb(246 246 246) !important"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "px-2 d-flex pb-1 font-weight-bold align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(item.wordingOriginal), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (item.dateRealization)
                                          ? (_openBlock(), _createBlock(_component_v_col, {
                                              key: 0,
                                              class: "pl-2 d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  style: _normalizeStyle(_ctx.dateStyle(item.dateRealization))
                                                }, _toDisplayString("Opération: " + _ctx.formatDate(item.dateRealization)), 5)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2 d-flex align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", {
                                              style: _normalizeStyle(_ctx.dateStyle(item.dateDebit))
                                            }, _toDisplayString("Valeur: " + _ctx.formatDate(item.dateDebit)), 5)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "pl-2 d-flex align-center justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            (item.amount > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(item.amount, undefined)), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "px-2 d-flex align-center justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            (item.amount < 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(-item.amount, undefined)), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  ]),
                                  _: 1
                                }, 8, ["items"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.associatedFields.show)
              ? (_openBlock(), _createBlock(_component_v_list, {
                  key: 0,
                  style: _normalizeStyle(_ctx.svgPosition)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associatedFields.fields, (field, key, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `field-${_ctx.document.id}-${key}-${index}`,
                        onClick: ($event: any) => (_ctx.onFieldAssociation(field, key)),
                        class: "oss-list-item"
                      }, null, 8, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "6",
          class: "my-0 pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important"},
              class: "default_card_wm fill-height elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              "single-line": "",
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[51] || (_cache[51] = [
                                                _createElementVNode("b", null, "Statut", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.document.errorMessage)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Erreur : " + _toDisplayString(_ctx.document.errorMessage), 1))
                                                  : (_ctx.document.status === 'VALIDATED')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Validé "))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.documentStatus), 1))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.document.data && _ctx.document.data.bank)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      ripple: false,
                                      class: "mb-2",
                                      color: "success"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, {
                                                  cols: "3",
                                                  class: "d-flex align-center",
                                                  style: {"border-right":"1px #ededed solid"}
                                                }, {
                                                  default: _withCtx(() => _cache[52] || (_cache[52] = [
                                                    _createElementVNode("b", null, "Autres données", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, {
                                                  cols: "6",
                                                  class: "d-flex align-center pl-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (
                                                            _ctx.bankTransactions.length !==
                                                            _ctx.document.data.bank
                                                                .toImportBankTransactionCount
                                                        )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                          _createVNode(_component_v_icon, {
                                                            color: "error",
                                                            size: "x-small",
                                                            left: ""
                                                          }, {
                                                            default: _withCtx(() => _cache[53] || (_cache[53] = [
                                                              _createTextVNode("$fa-exclamation-triangle")
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(" Nombre de mouvements importés: " + _toDisplayString(_ctx.bankTransactions.length) + " / " + _toDisplayString(_ctx.document.data.bank
                                                                .toImportBankTransactionCount), 1)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                          _createVNode(_component_v_icon, {
                                                            color: "secondary",
                                                            size: "x-small",
                                                            left: ""
                                                          }, {
                                                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                                                              _createTextVNode("$fa-check")
                                                            ])),
                                                            _: 1
                                                          }),
                                                          _createTextVNode(" Nombre de mouvements importés: " + _toDisplayString(_ctx.bankTransactions.length) + " / " + _toDisplayString(_ctx.document.data.bank
                                                                .toImportBankTransactionCount), 1)
                                                        ]))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "3" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_oss_date_picker_filled, {
                                      modelValue: _ctx.document.date,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.document.date) = $event)),
                                      "hide-details": true,
                                      label: _ctx.$t('shared.date'),
                                      mandatory: false,
                                      textFieldReadOnly: false,
                                      prefixDataCy: "DocumentBankStatement-documentDate"
                                    }, null, 8, ["modelValue", "label"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "9",
                                  class: "pl-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select_filled, {
                                      items: _ctx.accounts,
                                      "item-title": _ctx.formatBankAccount,
                                      "item-value": "id",
                                      label: "Compte bancaire",
                                      modelValue: _ctx.selectedAccount,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                                      class: "elevation-0",
                                      outlined: "",
                                      "hide-details": "",
                                      readonly: _ctx.accounts.length <= 1 || _ctx.fromEbics,
                                      density: "compact"
                                    }, null, 8, ["items", "item-title", "modelValue", "readonly"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.analysisDone)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "pt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          label: "Ancien Solde",
                                          regular: "",
                                          dense: "",
                                          "hide-details": true,
                                          outlined: "",
                                          modelValue: _ctx.startBalance,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.startBalance) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          regular: "",
                                          label: "Nouveau Solde",
                                          dense: "",
                                          "hide-details": true,
                                          outlined: "",
                                          modelValue: _ctx.endBalance,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.endBalance) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center pl-2",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          regular: "",
                                          "hide-details": true,
                                          outlined: "",
                                          label: "Calculé",
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.computedEndBalance,
                                                    undefined,
                                                )
                                            ,
                                          density: "compact"
                                        }, null, 8, ["model-value"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          color: !_ctx.endBalanceDelta ? 'primary' : 'red',
                                          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.endBalanceValidated = !_ctx.endBalanceValidated), ["stop"])),
                                          icon: 
                                                _ctx.endBalanceValidated
                                                    ? '$oss-circle-check'
                                                    : '$oss-circle-uncheck'
                                            ,
                                          size: "small"
                                        }, null, 8, ["color", "icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center pl-2 justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.endBalanceDelta)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.endBalanceDelta, undefined)), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "pt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          regular: "",
                                          dense: "",
                                          "hide-details": true,
                                          outlined: "",
                                          label: "Total débit",
                                          modelValue: _ctx.totalDebit,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.totalDebit) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center pl-2",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          regular: "",
                                          "hide-details": true,
                                          outlined: "",
                                          label: "Calculé",
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.computedTotalDebit,
                                                    undefined,
                                                )
                                            ,
                                          density: "compact"
                                        }, null, 8, ["model-value"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          color: !_ctx.totalDebitDelta ? 'primary' : 'red',
                                          onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.totalDebitValidated = !_ctx.totalDebitValidated), ["stop"])),
                                          icon: 
                                                _ctx.totalDebitValidated
                                                    ? '$oss-circle-check'
                                                    : '$oss-circle-uncheck'
                                            ,
                                          size: "small"
                                        }, null, 8, ["color", "icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center pl-2 justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.totalDebitDelta)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalDebitDelta, undefined)), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "pt-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          regular: "",
                                          dense: "",
                                          "hide-details": true,
                                          outlined: "",
                                          label: "Total crédit",
                                          modelValue: _ctx.totalCredit,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.totalCredit) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex align-center pl-2",
                                      style: {"border-right":"1px #ededed solid"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          regular: "",
                                          "hide-details": true,
                                          outlined: "",
                                          label: "Calculé",
                                          readonly: "",
                                          "model-value": 
                                                _ctx.newCommonFormatCurrency(
                                                    _ctx.computedTotalCredit,
                                                    undefined,
                                                )
                                            ,
                                          density: "compact"
                                        }, null, 8, ["model-value"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          color: !_ctx.totalCreditDelta ? 'primary' : 'red',
                                          onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (
                                                _ctx.totalCreditValidated = !_ctx.totalCreditValidated
                                            ), ["stop"])),
                                          icon: 
                                                _ctx.totalCreditValidated
                                                    ? '$oss-circle-check'
                                                    : '$oss-circle-uncheck'
                                            ,
                                          size: "small"
                                        }, null, 8, ["color", "icon"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center justify-end pl-2"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.totalCreditDelta)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalCreditDelta, undefined)), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.analysisDone)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, "Lignes bancaires (" + _toDisplayString(_ctx.identifiedBankTransactions.length) + ")", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "pl-2 d-flex align-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "pl-2 d-flex align-center justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_add_icon, {
                                  size: "x-small",
                                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.newBT()))
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.analysisDone && _ctx.errorCount)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 2,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex align-center col-auto" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_18, "Nombre d'erreur(s) : " + _toDisplayString(_ctx.errorCount), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "pl-2 d-flex align-center justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  "hide-details": "auto",
                                  modelValue: _ctx.filterErrorBTs,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.filterErrorBTs) = $event)),
                                  class: "mt-0",
                                  label: "Filtrer"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.analysisDone && _ctx.duplicateCount)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 3,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex align-center col-auto" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_19, "Nombre de doublon(s) : " + _toDisplayString(_ctx.duplicateCount), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "3",
                              class: "pl-2 d-flex align-center justify-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  "hide-details": "auto",
                                  modelValue: _ctx.removeDuplicates,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.removeDuplicates) = $event)),
                                  class: "mt-0",
                                  label: "Retirer"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_v_switch, {
                                  "hide-details": "auto",
                                  modelValue: _ctx.filterDuplicateBTs,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.filterDuplicateBTs) = $event)),
                                  class: "ml-2 mt-0",
                                  label: "Filtrer"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.analysisDone)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 4,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list, {
                                  style: {"background-color":"transparent","overflow-y":"auto"},
                                  width: "100%",
                                  height: "438",
                                  lines: "two"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredIdentifiedBankTransactions, (item) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: item.index,
                                        class: _normalizeClass(
                                            item.focus
                                                ? 'oss-list-item1-high mb-2'
                                                : !item.errorCount
                                                  ? 'oss-list-item1 mb-2'
                                                  : 'oss-list-item1-error mb-2'
                                        ),
                                        onClick: _withModifiers(($event: any) => (_ctx.onClickBT(item)), ["stop"]),
                                        onMouseover: ($event: any) => (_ctx.highlightBT(item, true, 'svg')),
                                        onMouseout: ($event: any) => (_ctx.highlightBT(item, false)),
                                        id: 'identified-bt-' + item.index,
                                        active: false,
                                        link: false
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "12",
                                                class: "d-flex pb-1 font-weight-bold align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_icon, {
                                                    color: "primary",
                                                    onClick: _withModifiers(($event: any) => (item.selected = !item.selected), ["stop"]),
                                                    size: "small",
                                                    icon: 
                                                        item.selected
                                                            ? '$oss-circle-check'
                                                            : '$oss-circle-uncheck'
                                                    
                                                  }, null, 8, ["onClick", "icon"]),
                                                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.wording), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              (_ctx.isDuplicates(item.index))
                                                ? (_openBlock(), _createBlock(_component_v_col, {
                                                    key: 0,
                                                    cols: "12",
                                                    class: "d-flex pb-1 font-weight-bold align-center"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, {
                                                        color: !_ctx.removeDuplicates ? 'red' : 'green',
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[55] || (_cache[55] = [
                                                          _createTextVNode(" $report_problem ")
                                                        ])),
                                                        _: 1
                                                      }, 8, ["color"]),
                                                      _createElementVNode("span", {
                                                        class: "pl-2",
                                                        style: _normalizeStyle(
                                                        !_ctx.removeDuplicates
                                                            ? 'color:red;'
                                                            : 'color:green'
                                                    )
                                                      }, _toDisplayString(!_ctx.removeDuplicates
                                                            ? "Doublon"
                                                            : "Doublon retiré"), 5)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "px-1 d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  (item.dateRealization)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        style: _normalizeStyle(_ctx.dateStyle(item.dateRealization))
                                                      }, " Opération :  " + _toDisplayString(_ctx.formatDate(item.dateRealization)), 5))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "4",
                                                class: "px-1 d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    style: _normalizeStyle(_ctx.dateStyle(item.dateDebit))
                                                  }, " Valeur : " + _toDisplayString(_ctx.formatDate(item.dateDebit)), 5)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "2",
                                                class: "px-1 d-flex align-center justify-end"
                                              }, {
                                                default: _withCtx(() => [
                                                  (item.amountSigned < 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        -item.amountSigned,
                                                        undefined,
                                                    )), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_v_col, {
                                                cols: "2",
                                                class: "px-1 d-flex align-center justify-end"
                                              }, {
                                                default: _withCtx(() => [
                                                  (item.amountSigned > 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        item.amountSigned,
                                                        undefined,
                                                    )), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick", "onMouseover", "onMouseout", "id"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.activateTagguing)
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FreeTag, {
                                  companyTags: _ctx.allCompanyTags,
                                  document: _ctx.inDocument,
                                  splitUserPartitions: true,
                                  onChanged: _ctx.startToBeDoneIfNecessary
                                }, null, 8, ["companyTags", "document", "onChanged"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.mode !== 'GeneralLedger')
                  ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: _ctx.onlyBalances,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.onlyBalances) = $event)),
                                  label: "Importer uniquement les soldes bancaires"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex justify-end align-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, [
                                  (_ctx.selectedCompany.solution !== 'MANAGEMENT')
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 0,
                                        location: "top"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn_warning, _mergeProps({
                                            size: "x-small",
                                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.setOpenChat('DENIED'))),
                                            class: "mr-1",
                                            disabled: _ctx.document.status === 'DENIED'
                                          }, props), null, 16, ["disabled"])
                                        ]),
                                        default: _withCtx(() => [
                                          _cache[56] || (_cache[56] = _createElementVNode("span", null, "Rejeter", -1))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.displayDocumentValidationSpeedRun(_ctx.document.status))
                                    ? (_openBlock(), _createBlock(_component_DocumentValidationSpeedRun, {
                                        key: 1,
                                        modelValue: _ctx.lastDocumentValidationDone,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.lastDocumentValidationDone) = $event))
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_v_btn, {
                                    rounded: "",
                                    class: "elevation-0 ml-1",
                                    disabled: _ctx.disabledValidate,
                                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onFormValidation())),
                                    loading: _ctx.loading,
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.validated ? "Validé" : "Valider") + " ", 1),
                                      _withDirectives(_createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[57] || (_cache[57] = [
                                          _createTextVNode("$check")
                                        ])),
                                        _: 1
                                      }, 512), [
                                        [_vShow, _ctx.validated]
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["disabled", "loading"])
                                ]),
                                _createVNode(_component_v_btn_prev, {
                                  disabled: _ctx.previousDisabled(),
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.previous()))
                                }, null, 8, ["disabled"]),
                                _createVNode(_component_v_btn_next, {
                                  disabled: _ctx.nextDisabled(),
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.next()))
                                }, null, 8, ["disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_DocumentWizardDialog, {
      active: _ctx.activeUploadDocument,
      "onUpdate:active": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.activeUploadDocument) = $event)),
      companyId: _ctx.companyId,
      documentId: _ctx.document.id,
      documentType: _ctx.document.type,
      showFirstPrevious: false,
      multiple: false,
      onFileUploaded: _ctx.onFileUploaded
    }, null, 8, ["active", "companyId", "documentId", "documentType", "onFileUploaded"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.analyseDocumentDialog,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.analyseDocumentDialog) = $event)),
      title: "Relancer l'analyse du document",
      onValid: _ctx.analyseDocument,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[58] || (_cache[58] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir relancer l'analyse ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.dialogChooseDownload,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.dialogChooseDownload) = $event)),
      title: "Télécharger le document",
      width: "800px"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: _ctx.enableDownloadWorkingCopy ? 4 : 6,
              class: "pr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[35] || (_cache[35] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(true);
                            }),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[59] || (_cache[59] = [
                    _createTextVNode("Original")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["cols"]),
            (_ctx.enableDownloadWorkingCopy)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "4",
                  class: "px-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_primary, {
                      rounded: "",
                      block: "",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(true, true);
                            }),
                      size: "x-large"
                    }, {
                      default: _withCtx(() => _cache[60] || (_cache[60] = [
                        _createTextVNode("Travail (PNG)")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, {
              cols: _ctx.enableDownloadWorkingCopy ? 4 : 6,
              class: "pl-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_primary, {
                  rounded: "",
                  block: "",
                  onClick: _cache[37] || (_cache[37] = ($event: any) => {
                                _ctx.dialogChooseDownload = false;
                                _ctx.downloadFile(false);
                            }),
                  size: "x-large"
                }, {
                  default: _withCtx(() => _cache[61] || (_cache[61] = [
                    _createTextVNode("Marqué")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["cols"])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[62] || (_cache[62] = _createTextVNode(" Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté). "))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      onValid: _ctx.deleteDocument,
      error: true,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[63] || (_cache[63] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.warningValidationDialog,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.warningValidationDialog) = $event)),
      title: "Revalidation du document",
      onValid: _cache[41] || (_cache[41] = ($event: any) => {
                _ctx.validForm();
                _ctx.warningValidationDialog = false;
            }),
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[64] || (_cache[64] = [
        _createElementVNode("h4", { class: "text-center" }, " Si vous revalidez, certaines modifications apportées (affectation, lettrage,…) peuvent être supprimées. ", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "validLoading"]),
    (_ctx.editBT)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.btDialog,
          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.btDialog) = $event)),
          title: "Modifier la ligne bancaire",
          onValid: _ctx.validateBT,
          onClose: _cache[48] || (_cache[48] = ($event: any) => (_ctx.selectedBT = null)),
          validTitle: _ctx.selectedBT ? 'Modifier' : 'Ajouter',
          validDisabled: !_ctx.editBTIsValid,
          "max-width": "1200px",
          "min-width": "1000px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: _ctx.editBTIsValid,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.editBTIsValid) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "mx-2 pt-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '2',
                      class: "pb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_date_picker_filled, {
                          modelValue: _ctx.editBT.dateRealization,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.editBT.dateRealization) = $event)),
                          filterWithoutClosedAccountingPeriods: true,
                          "hide-details": "",
                          textFieldReadOnly: false,
                          label: "Opération",
                          prefixDataCy: "DocumentBankStatement-dateRealization"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '2',
                      class: "pl-2 pb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_date_picker_filled, {
                          modelValue: _ctx.editBT.dateDebit,
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.editBT.dateDebit) = $event)),
                          filterWithoutClosedAccountingPeriods: true,
                          "hide-details": "",
                          textFieldReadOnly: false,
                          label: "Valeur",
                          prefixDataCy: "DocumentBankStatement-dateDebit"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '',
                      class: "pl-2 pb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          outlined: "",
                          "hide-details": true,
                          modelValue: _ctx.editBT.wording,
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.editBT.wording) = $event)),
                          "single-line": "",
                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                          density: "compact"
                        }, null, 8, ["modelValue", "rules"])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '2',
                      class: "pl-2 pb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_text_field_filled, {
                          outlined: "",
                          "hide-details": true,
                          suffix: "€",
                          "single-line": "",
                          dense: "",
                          rules: [
                                (v) =>
                                    (!!v && _ctx.editBT.amountSigned !== 0) ||
                                    _ctx.$t('settings.itemRequired'),
                            ],
                          modelValue: _ctx.editBT.amountSigned,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.editBT.amountSigned) = $event))
                        }, null, 8, ["rules", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["cols"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue", "onValid", "validTitle", "validDisabled"]))
      : _createCommentVNode("", true),
    (_ctx.openChat)
      ? (_openBlock(), _createBlock(_component_Chat, {
          key: 1,
          id: _ctx.document.chat ? _ctx.document.chat.id : '',
          inShowMessage: _ctx.open_chat,
          chatTitle: 'Document',
          chatSubtitle: _ctx.getChatSubTitle(),
          showSmartChat: false,
          onMessageSent: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onMessageSent($event))),
          onShowMessageChanged: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onShowMessageChanged($event)))
        }, null, 8, ["id", "inShowMessage", "chatSubtitle"]))
      : _createCommentVNode("", true)
  ]))
}